export default __webpack_public_path__ + "static/media/NCFirstClass_Logo-Variations-02.72f30afa.png";